import React from 'react';
import { Container, Row, Col, Button, Table } from 'react-bootstrap';
import { useCart } from '../../context/CartContext.jsx';
import { useNavigate, Link } from 'react-router-dom';
import './Cart.scss';

const Cart = () => {
    const { cartItems, removeFromCart, updateQuantity, cartTotal, clearCart } = useCart();
    const navigate = useNavigate();

    if (cartItems.length === 0) {
        return (
            <div className="empty-cart-page sectionPadding">
                <Container className="text-center">
                    <div className="empty-cart-icon mb-4">
                        <i className="fas fa-shopping-basket"></i>
                    </div>
                    <h2 className="title-xl mb-3">Your Cart is Empty</h2>
                    <p className="mb-4">Looks like you hasn't added anything to your cart yet.</p>
                    <Link to="/" className="dBtn btnPrimary">RETURN TO SHOP</Link>
                </Container>
            </div>
        );
    }

    return (
        <div className="cart-page sectionPadding">
            <Container>
                <div className="cart-header mb-5" data-aos="fade-down">
                    <h4 className="section-title-sm">Review Your Items</h4>
                    <h1 className="title-xl fw-bold">SHOPPING CART</h1>
                </div>

                <Row className="g-5">
                    <Col lg={8} data-aos="fade-right">
                        <div className="cart-items-wrapper info-card">
                            <Table className="cart-table">
                                <thead>
                                    <tr>
                                        <th>PRODUCT</th>
                                        <th>PRICE</th>
                                        <th>QUANTITY</th>
                                        <th>SUBTOTAL</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {cartItems.map((item) => (
                                        <tr key={`${item.id}-${item.size}`}>
                                            <td data-label="PRODUCT">
                                                <div className="product-cell d-flex align-items-center gap-3">
                                                    <div className="product-img">
                                                        <img src={item.productImage} alt={item.title} />
                                                    </div>
                                                    <div className="product-info">
                                                        <h6 className="mb-1">{item.title}</h6>
                                                        <p className="mb-0 text-muted">Size: {item.size}</p>
                                                    </div>
                                                </div>
                                            </td>
                                            <td data-label="PRICE" className="align-middle">${item.price}</td>
                                            <td data-label="QUANTITY" className="align-middle">
                                                <div className="quantity-control d-flex align-items-center">
                                                    <button onClick={() => updateQuantity(item.id, item.size, item.quantity - 1)}>-</button>
                                                    <span>{item.quantity}</span>
                                                    <button onClick={() => updateQuantity(item.id, item.size, item.quantity + 1)}>+</button>
                                                </div>
                                            </td>
                                            <td data-label="SUBTOTAL" className="align-middle fw-bold">${(parseFloat(item.price) * item.quantity).toFixed(2)}</td>
                                            <td className="align-middle text-end">
                                                <button className="remove-btn" onClick={() => removeFromCart(item.id, item.size)}>
                                                    <i className="fas fa-trash-alt"></i>
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                            <div className="cart-actions d-flex justify-content-between mt-4">
                                <Link to="/" className="dBtn btnBorder">CONTINUE SHOPPING</Link>
                                <Button variant="link" className="text-danger p-0" onClick={clearCart}>Clear Shopping Cart</Button>
                            </div>
                        </div>
                    </Col>

                    <Col lg={4} data-aos="fade-left">
                        <div className="order-summary-card info-card p-4">
                            <h4 className="title-sm fw-bold mb-4">ORDER SUMMARY</h4>
                            <div className="summary-row d-flex justify-content-between mb-3">
                                <span>Subtotal</span>
                                <span>${cartTotal.toFixed(2)}</span>
                            </div>
                            <div className="summary-row d-flex justify-content-between mb-3">
                                <span>Shipping</span>
                                <span className="text-success">FREE</span>
                            </div>
                            <div className="summary-row d-flex justify-content-between mb-4 pb-3 border-bottom">
                                <span>Tax (GST)</span>
                                <span>$0.00</span>
                            </div>
                            <div className="summary-row total-row d-flex justify-content-between mb-4">
                                <span className="fw-bold fs-5">Total</span>
                                <span className="fw-bold fs-5">${cartTotal.toFixed(2)}</span>
                            </div>
                            <Button
                                className="dBtn btnPrimary w-100"
                                onClick={() => navigate('/checkout')}
                            >
                                PROCEED TO CHECKOUT
                            </Button>
                            <div className="payment-icons mt-4 text-center">
                                <i className="fab fa-cc-visa mx-2 fs-3 text-muted"></i>
                                <i className="fab fa-cc-mastercard mx-2 fs-3 text-muted"></i>
                                <i className="fab fa-cc-paypal mx-2 fs-3 text-muted"></i>
                                <i className="fab fa-cc-apple-pay mx-2 fs-3 text-muted"></i>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default Cart;
